/**
 * The canonical URL sort wire format (`sort=field` asc / `sort=-field` desc)
 * — see .claude/rules/query-params.md. One home; do not re-declare per screen.
 */
export const SortDirection = {
  ASCENDING: "asc",
  DESCENDING: "desc",
} as const;
export type SortDirection = (typeof SortDirection)[keyof typeof SortDirection];
